import { Lob, Lang } from 'src/app/shared/models/lob.enum';
import { _User } from 'src/app/shared/models/user';

export class InitRequest {
     AdsContentReq: { LOB:string, Locale: string, Generic:boolean }
     constructor(){
          this.AdsContentReq={LOB:Lob.IE, Locale:Lang.EN,Generic:false};
     }
}
